export const LEGAL_UPDATED = "21 de outubro de 2026";

export const CONTROLLER = {
  name: "Pop and Taste Unipessoal",
  nif: "515 622 699",
  address: "Rotunda Nuno Rodrigues Santos 1 B, 4 D, 2685-223 Portela LRS",
  email: "rgpd@popandtaste.com",
};

export const PRIVACY = [
  {
    title: "1. Quem é o responsável pelo tratamento",
    body: [
      `O responsável pelo tratamento dos dados pessoais recolhidos através da aplicação The Cellar Book é ${CONTROLLER.name}, NIF ${CONTROLLER.nif}, com sede em ${CONTROLLER.address}.`,
      `Para qualquer questão sobre privacidade pode contactar-nos através de ${CONTROLLER.email}.`,
    ],
  },
  {
    title: "2. Que dados tratamos",
    list: [
      "Contas com email: nome, endereço de email e palavra-passe (guardada apenas de forma cifrada, nunca em texto legível).",
      "Acesso por código de Cave: o nome que escolher escrever (opcional). O código de 4 dígitos é guardado apenas de forma cifrada.",
      "Registo de movimentos: data, hora, garrafa ou caixa, localização de origem e destino, ação (mudança de localização, consumo, venda, perda), notas e preço de venda indicados, e o nome de quem fez a ação.",
      "Dados da adega: vinhos, produtores, colheitas, fornecedores, preços e datas de compra, notas, localizações e caixas. Em regra não são dados pessoais, salvo se incluir nomes de pessoas nas notas ou no campo de fornecedor/comprador.",
      "Dados técnicos de segurança: endereço IP e email usados em tentativas de acesso falhadas, para bloquear tentativas repetidas.",
    ],
  },
  {
    title: "3. Para que fins e com que fundamento",
    list: [
      "Permitir o acesso à aplicação e às Caves e manter a sessão iniciada — execução do serviço pedido pelo utilizador (art. 6.º, n.º 1, al. b) do RGPD).",
      "Gerir o inventário e o histórico de movimentos da adega — interesse legítimo do responsável em controlar o seu stock (art. 6.º, n.º 1, al. f) do RGPD).",
      "Proteger a aplicação contra acessos indevidos e tentativas de adivinhar códigos ou palavras-passe — interesse legítimo na segurança do serviço (art. 6.º, n.º 1, al. f) do RGPD).",
    ],
  },
  {
    title: "4. Durante quanto tempo guardamos os dados",
    list: [
      "Contas de utilizador: enquanto a conta existir; são apagadas quando o proprietário remove o utilizador.",
      "Movimentos e dados da adega: enquanto a Cave ou o vinho existirem na aplicação.",
      "Registos de tentativas de acesso falhadas: eliminados automaticamente até 1 hora depois.",
      "Cookies de sessão: ver a Política de Cookies (máximo de 7 dias).",
    ],
  },
  {
    title: "5. Com quem partilhamos os dados",
    body: [
      "Não vendemos nem cedemos dados pessoais a terceiros para fins comerciais.",
      "Os dados são guardados em servidores do fornecedor de alojamento da aplicação (Emergent), que atua como subcontratante e trata os dados apenas para prestar este serviço.",
      "As fontes de letra da aplicação são carregadas a partir do Google Fonts (Google). Ao abrir a aplicação, o seu navegador liga-se aos servidores da Google, que recebem o seu endereço IP. A Google pode tratar esses dados fora da União Europeia, ao abrigo das garantias previstas no RGPD.",
    ],
  },
  {
    title: "6. Os seus direitos",
    body: [
      "Nos termos do RGPD, tem direito de acesso, retificação, apagamento, limitação do tratamento, oposição e portabilidade dos seus dados.",
      `Para exercer estes direitos contacte ${CONTROLLER.email}. Responderemos no prazo máximo de um mês.`,
      "Tem também o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD) — www.cnpd.pt.",
    ],
  },
  {
    title: "7. Segurança",
    body: [
      "As comunicações com a aplicação são cifradas (HTTPS). As palavras-passe e os códigos das Caves são guardados de forma cifrada. Tentativas repetidas de acesso com códigos errados são bloqueadas temporariamente.",
    ],
  },
  {
    title: "8. Alterações a esta política",
    body: ["Podemos atualizar esta política. A data da última atualização está indicada no topo desta página."],
  },
];

export const COOKIES = [
  {
    title: "1. O que são cookies",
    body: [
      "Cookies são pequenos ficheiros guardados no seu navegador quando visita um site. Servem, por exemplo, para manter a sessão iniciada entre páginas.",
    ],
  },
  {
    title: "2. Que cookies usamos",
    body: [
      "A aplicação The Cellar Book usa apenas cookies estritamente necessários ao seu funcionamento. Não usamos cookies de publicidade, de estatística nem de redes sociais. Por isso estes cookies não precisam de consentimento prévio, mas informamos sobre eles aqui.",
    ],
    table: [
      ["access_token", "Mantém a sessão iniciada (conta ou código da Cave)", "Necessário", "15 minutos"],
      ["refresh_token", "Renova a sessão sem pedir novamente o código ou a palavra-passe", "Necessário", "7 dias"],
    ],
  },
  {
    title: "3. Armazenamento local do navegador",
    body: ["Além dos cookies, a aplicação guarda no seu navegador (e nunca envia para terceiros):"],
    table: [
      ["cellar_name", "O nome que escreveu ao entrar com código, para não ter de o escrever de novo", "Funcional", "Até o apagar"],
      ["cellar_cookie_notice", "Lembra que já viu o aviso de cookies", "Funcional", "Até o apagar"],
      ["cellar_labels", "Etiquetas escolhidas para impressão", "Funcional", "Até fechar o separador"],
    ],
  },
  {
    title: "4. Serviços de terceiros",
    body: [
      "As fontes de letra são carregadas a partir do Google Fonts. Este serviço não coloca cookies através da aplicação, mas recebe o seu endereço IP ao carregar as fontes. Consulte a Política de Privacidade da Google em policies.google.com/privacy.",
    ],
  },
  {
    title: "5. Como gerir ou apagar cookies",
    body: [
      "Pode apagar os cookies e o armazenamento local a qualquer momento nas definições do seu navegador. Se bloquear os cookies necessários, não conseguirá entrar na aplicação. Ao terminar a sessão (Sign out), os cookies de sessão são apagados.",
      `Para dúvidas contacte ${CONTROLLER.email}.`,
    ],
  },
];
